@if (platformBrowser) {
  <div class="page center">
    <img src="/assets/icons/special/time-circle.svg" alt="" />

    @if (maintenanceService.getMaintenance(true) | async; as outage) {
      <h1>Scheduled Maintenance</h1>
      <p class="standard-text">
        {{ outage.duringOutageText | replace : '{{endTime}}' : (outage.toDate | date : 'shortTime') | replace : '{{
          startTime
        }}' : (outage.fromDate | date : 'shortTime') }}
      </p>
    } @else {
      <h1>Unscheduled Maintenance</h1>
      <p class="standard-text">We’re is currently undergoing some unexpected maintenance.</p>
    }

    <p class="standard-text legal"><b>Note:</b> This page will refresh automatically when we’re back.</p>
  </div>
}
